export default __webpack_public_path__ + "locales/ar-SA/HotkeysPanel.json?hash=f0716033a5c5bd0848df683d642fe66c";